import { useEffect, useState, Suspense } from 'react'
import { useChatStore, useUserStore } from '@client/store'
import { ChatPageSpinner, ChatMain } from '@components'
import clsx from 'clsx'

interface ChatContainerProps {
  className?: string
  chat_uuid: string
}

export function ChatContainer({
  className = '',
  chat_uuid,
}: ChatContainerProps) {
  const { character } = useChatStore()
  const { imageURL } = useUserStore()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)
    setIsLoading(false)
  }, [imageURL, character?.profile_image])

  return (
    <Suspense fallback={<ChatPageSpinner />}>
      <div
        className={clsx(
          'flex flex-col flex-1 min-w-0 min-h-0 relative',
          className
        )}
      >
        {isLoading ? (
          <ChatPageSpinner />
        ) : (
          <ChatMain setIsGenerating={() => {}} chat_uuid={chat_uuid} />
        )}
      </div>
    </Suspense>
  )
}